// Section 9 and 13: Palisade. 20 build points, 24 wood; raid damage 0.5x; wild-animal events
// 0.3x; requires 2 guards to count. The wild-animal event weight is scaled here; raid losses are
// scaled by the events stream with `palisadeStrength` (core/queries.ts). Limit 1.
// Constants: config.buildings.palisade.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { isWorking, palisadeStrength, peopleSorted } from '../../core/queries';
import { buildingEffectHook, combineModifiers, noDeltas } from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';
import type { ReadContext } from '../../core/types';

function guardsWorking(ctx: ReadContext): number {
  let n = 0;
  for (const p of peopleSorted(ctx.state)) if (p.job === 'guard' && isWorking(p)) n++;
  return n;
}

export function palisade(config: Config) {
  const c = config.buildings.palisade;

  return defineBuilding({
    id: 'palisade',
    label: 'Palisade',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood },
    material: 'wood',
    beds: 0,
    plots: 0,
    capacity: {},
    limit: { kind: 'fixed', max: c.limit },
    modifierTargets: ['eventWeight', 'buildingEffect'],
    modifiers: combineModifiers(
      buildingEffectHook('palisade', (ctx) =>
        guardsWorking(ctx) >= c.guardsRequired ? null : `needs ${c.guardsRequired} guards`,
      ),
      (ctx, target) => {
        if (target.kind !== 'eventWeight' || target.eventId !== 'wild-animals') return [];
        const e = palisadeStrength(ctx.cfg, ctx.state);
        return e > 0 ? [mod.mul('building:palisade', 1 - (1 - c.wildAnimals) * e, 'palisade')] : [];
      },
    ),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
